import { FileUploadOrDownload, Session, SessionType } from "./types";

export function getTotalSessionSize(
	session: Session<FileUploadOrDownload>,
): number {
	return session.items.reduce<number>((acc, item) => {
		let size = 0;

		if (item.type === SessionType.Upload && item.source) {
			size = item.source.size;
		}

		return acc + size;
	}, 0);
}
